import {RootState} from "@/store/Store";
import {createSlice, PayloadAction} from "@reduxjs/toolkit";

export interface RequisitesFormsInterface {
    formVisible: boolean;
    formVariant: "new" | "edit";
    editId: number | null;
    editTitle: string;
    editAlias: string;
    deleteModalVisible: boolean;
    deleteId: number | null;
}

const getInitialState = (): RequisitesFormsInterface => ({
    formVariant: "new",
    formVisible: false,
    editId: null,
    editTitle: "",
    editAlias: "",
    deleteModalVisible: false,
    deleteId: null,
});

export const RequisitesFormsSlice = createSlice({
    name: "requisitesForms",
    initialState: getInitialState(),
    reducers: {
        openForm: (state, action: PayloadAction<"new" | "edit">) => {
            state.formVisible = true;
            state.formVariant = action.payload
        },
        closeForm: (state) => {
            state.formVisible = false;
        },
        changeEditId: (state, action: PayloadAction<number | null>) => {
            state.editId = action.payload;
        },
        changeEditTitle: (state, action: PayloadAction<string>) => {
            state.editTitle = action.payload;
        },
        changeEditAlias: (state, action: PayloadAction<string>) => {
            state.editAlias = action.payload;
        },
        openDeleteModal: (state) => {
            state.deleteModalVisible = true;
        },
        closeDeleteModal: (state) => {
            state.deleteModalVisible = false;
        },
        changeDeleteId: (state, action: PayloadAction<number | null>) => {
            state.deleteId = action.payload;
        },
        reset: () => getInitialState(),
    },
});

export const {
    openForm,
    closeForm,
    changeEditId,
    changeEditTitle,
    changeEditAlias,
    openDeleteModal,
    closeDeleteModal,
    reset,
    changeDeleteId,
} = RequisitesFormsSlice.actions;

export const selectFormVisible = (state: RootState) => state.requisitesForms.formVisible;
export const selectFormVariant = (state: RootState) => state.requisitesForms.formVariant;
export const selectEditId = (state: RootState) => state.requisitesForms.editId;
export const selectEditTitle = (state: RootState) => state.requisitesForms.editTitle;
export const selectEditAlias = (state: RootState) => state.requisitesForms.editAlias;
export const selectDeleteModalVisible = (state: RootState) => state.requisitesForms.deleteModalVisible;
export const selectDeleteId = (state: RootState) => state.requisitesForms.deleteId;


export const RequisitesFormsReducer = RequisitesFormsSlice.reducer;
